import { HedgingInstrumentInterestRateMode } from '../../../../models/HedgingInstrument/enum';
import { LegTypes } from '../../../../models/Leg/enum';
import { LegFlow } from '../../../../models/LegFlow';
import { LegTerms } from '../../../../models/LegTerms';

export const EXCLUDED_FIELDS_FOR_COPY_PASTE: Array<keyof LegTerms> = [
  'transaction_leg_id',
  'leg_type_id',
  'pay_receive_id',
  'current_notional_leg',
];
export const EXCLUDED_FIELDS_FOR_COPY_PASTE_FLOWS: Array<keyof LegFlow> = [
  'rowId',
  'resetDate',
  'startDate',
  'endDate',
  'payDate',
  'notional',
];

export const CALCULATION_CALENDAR_UPDATE_LEGS_LIST = [
  LegTypes.fixed,
  LegTypes.float,
  LegTypes.cap,
  LegTypes.floor,
  LegTypes.inflation,
  LegTypes.payGo,
  LegTypes.compoundingFixed,
  LegTypes.commodityFixed,
  LegTypes.commodityFloat,
  LegTypes.commodityCall,
  LegTypes.commodityPut,
];

export const FORECASTING_INDEX_RESET_CALENDAR_UPDATE_LEGS_LIST = [
  LegTypes.float,
  LegTypes.cap,
  LegTypes.floor,
];

export const FX_FORWARD_INSTRUMENTS: HedgingInstrumentInterestRateMode[] = [
  HedgingInstrumentInterestRateMode.fxForward,
  HedgingInstrumentInterestRateMode.fxAveragingForward,
  HedgingInstrumentInterestRateMode.fxForwardNDF,
];
